import { bugsnagClient as bugsnag } from './bugsnag';
const logger = console;
const isProduction = process.env.NODE_ENV === 'production';

const getEventData = ({
  context = null,
  metaData = null,
  severity = 'error'
} = {}) => {
  const base = {
    context,
    metaData,
    severity
  };

  return base;
};

export default {
  debug(...args) {
    logger.debug(...args);
  },
  error(err, options) {
    if (isProduction) {
      bugsnag.notify(err, getEventData(options));
    }
    logger.error(err, options);
  },
  info(...args) {
    logger.info(...args);
  },
  // Logs an error to the console, and sends a full exception, including
  // traceback, to sentry.
  logException(e, ...msgArgs) {
    if (isProduction) {
      window.Raven.captureException(e);
    }
    logger.error(e, ...msgArgs);
  },
  warn(err, options) {
    if (isProduction) {
      bugsnag.notify(
        err,
        Object.assign({}, getEventData(options), { severity: 'warning' })
      );
    }
    logger.warn(err, options);
  }
};



// WEBPACK FOOTER //
// ./src/logger/index.js